import { translateBackend } from '@assets/i18n/config';
import { Grid } from '@ovComponents/1-primative/grid/grid';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { SelectionTile } from '@ovComponents/3-pattern/selectionTile/selectionTile';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { AnalyticsContext } from '@providers/analyticsProvider';
import { ovAnalyticsEvents } from '@utils/analytics/analytics';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { NonIndividualSetupConfirmationDialog } from './components/NonIndividualSetupConfirmationDialog';

export const NonIndividualSetupVisual = ({
  options,
  loading,
  onNext,
  createNonIndividualEntity,
  workflowCompletion,
}: {
  options: any;
  loading: boolean;
  onNext: () => void;
  createNonIndividualEntity?: () => void;
  workflowCompletion?: any;
}) => {
  const { sendAnalytic } = useContext(AnalyticsContext);
  const { t } = useTranslation(['client', 'entityTypes', 'shared']);
  const [shouldCreateNonIndividualEntity, setShouldCreateNonIndividualEntity] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const submit = async () => {
    sendAnalytic(
      ovAnalyticsEvents.workflowsNonIndividualSetupContinueButtonSelect,
      {
        workflowStepTitle: options?.title,
        workflowId: workflowCompletion?.workflow?.id,
        workflowName: workflowCompletion?.workflow?.name,
        activeWorkflowCompletionId: workflowCompletion?.id,
        objectId: workflowCompletion?.objectId,
        objectType: workflowCompletion.objectType,
      },
    );
    if (shouldCreateNonIndividualEntity) {
      setIsModalOpen(true);
    } else {
      await onNext();
    }
  };

  return (
    <>
      <WorkflowCompletionForm
        onSubmit={submit}
        submitButtonProps={{
          label: t('shared:next'),
          disabled: loading,
          dataTestId: 'non-individual-setup-next-button',
        }}
      >
        {options?.title && (
          <Typography variant='displayLarge' sx={{ mt: 1 }}>
            {translateBackend(options?.title)}
          </Typography>
        )}
        {options?.subtitle && (
          <Typography variant='bodyLarge' sx={{ mb: 3 }}>
            <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
              {translateBackend(options?.subtitle)}
            </ReactMarkdown>
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SelectionTile
              testId='non-individual-setup-selection'
              onChange={(e: any) =>
                setShouldCreateNonIndividualEntity(e.target.value === 'Y')
              }
              value={shouldCreateNonIndividualEntity ? 'Y' : 'N'}
              direction='row'
              options={[
                { value: 'Y', label: t('shared:yes') },
                { value: 'N', label: t('shared:no') },
              ]}
            />
          </Grid>
        </Grid>
      </WorkflowCompletionForm>
      <NonIndividualSetupConfirmationDialog
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        createNonIndividualEntity={createNonIndividualEntity}
        title={translateBackend(options.confirmationTitle)}
        text={translateBackend(options.confirmationText)}
        loading={loading}
      />
    </>
  );
};

export default NonIndividualSetupVisual;
